<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">菜单管理</div>
    <!--右侧内容-->
    <div class="gj_right">
      <div class="gj_top_class">
        <a @click="edit('')" class="btn btn_add">新增菜单</a>
      </div>
      <div class="gj_list">
        <h5 class="none_ts" v-if="!data">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <zk-table
          ref="table"
          sum-text="sum"
          index-text="#"
          :data="data"
          :columns="columns"
          :stripe="props.stripe"
          :border="props.border"
          :show-header="props.showHeader"
          :show-summary="props.showSummary"
          :show-row-hover="props.showRowHover"
          :show-index="props.showIndex"
          :tree-type="props.treeType"
          :is-fold="props.isFold"
          :expand-type="props.expandType"
          :selection-type="props.selectionType">
          <!--template slot="$expand" slot-scope="scope">
            <div>排序: {{scope.row.sort}}</div>
            <div>是否需要登录: {{scope.row.isAllow == '0' ? '否' : '是'}}</div>
            <div>是否可见: {{scope.row.isShow == '0' ? '隐藏': '可见'}}</div>
          </template-->
          <!--template slot="isAllow" slot-scope="scope">
            {{ scope.row.isAllow == '0' ? '否' : '是' }}
          </template-->
          <template slot="actions" slot-scope="scope">
            <span class="xo-table-btn" @click="edit(scope.row.id)">编辑</span>
            <span class="xo-table-btn" @click="del(scope.row.id)">删除</span>
            <span class="xo-table-btn" @click="addchild(scope.row)">新增下级菜单</span>
          </template>
        </zk-table>
        <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                  :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text></paginate>
      </div>
    </div>
    <!--/右侧内容-->
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import Vue from 'vue'
  import utils from '@/utils'
  import ZkTable from 'vue-table-with-tree-grid'
  export default {
    components: {ZkTable},
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        filters: {
          isShow: '',
          roleList: []
        },
        props: {
          stripe: false,
          border: true,
          showHeader: true,
          showSummary: false,
          showRowHover: true,
          showIndex: false,
          treeType: true,
          isFold: true,
          expandType: false, // 是否为展开行类型表格（为 True 时，需要添加名称为 '$expand' 的作用域插槽, 它可以获取到 row, rowIndex)
          selectionType: false
        },
        data: [],
        columns: [
          {
            label: '名称',
            prop: 'name'
            // width: '200px'
          },
          {
            label: '链接',
            prop: 'href'
          },
          {
            label: '接口名称',
            prop: 'permission'
          },
          {
            label: '操作',
            prop: 'actions',
            width: '220px',
            type: 'template',
            template: 'actions'
          }
        ],
        pages: 0,
        prefix: this.$route.meta.prefix || ''
      };
    },
    computed: {
      propList () {
        return Object.keys(this.props).map(item => ({
          name: item
        }));
      }
    },
    methods: {
      addchild (item) {
        this.$router.push({path: this.prefix + '/org/menu/'+ item.id + '/' + item.id})
      },
      edit (id) {
        var pid = 'void'
        if (id == '') {
          id = 'void'
        }
        this.$router.push({path: this.prefix + '/org/menu/'+ id + '/' + pid})
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '删除',
          text: '确认删除吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            yes: function () {
              api.get(config.bylBaseCenterPath, '/menu/delete', { id: id }, r => {
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.bylBaseCenterPath, '/menu/list', filters, function (r) { // 正常
          that.data = r.data
        })
      }
    }
  }
</script>

<style scoped>
  .xo-table-btn {
    padding: 5px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/orgmenu/list.vue